// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602061705/js/" + chunkId + "." + {"44":"87590c7b","225":"9f7458d2","481":"c039dd5e","486":"ff357de1","770":"b7918005"}[chunkId] + ".0.6458394122773257.chunk.js";
};